import React, { memo } from 'react';
import { SearchIcon } from '../../../common/Icons';

interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
}

const SearchInput = memo<SearchInputProps>(({
  value,
  onChange,
  placeholder = "검색...",
  disabled = false
}) => (
  <div className="relative">
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      className="w-full px-4 py-2 pl-10 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
    />
    <div className="absolute inset-y-0 left-0 flex items-center pl-3">
      <SearchIcon className="w-5 h-5 text-gray-400" />
    </div>
  </div>
));

interface SearchStatsProps {
  total: number;
  filtered: number;
  isSearching: boolean;
}

const SearchStats = memo<SearchStatsProps>(({ total, filtered, isSearching }) => {
  if (!isSearching) return null;

  return (
    <div className="text-sm text-gray-600">
      {filtered}개 결과 (전체 {total}개)
    </div>
  );
});

interface BillingSettingsFiltersProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchStats?: {
    total: number;
    filtered: number;
    isSearching: boolean;
  };
  disabled?: boolean;
}

const BillingSettingsFilters = memo<BillingSettingsFiltersProps>(({
  searchTerm,
  onSearchChange,
  searchStats,
  disabled = false
}) => (
  <div className="mb-6">
    <div className="flex items-center justify-between space-x-4">
      <div className="flex-1 max-w-md">
        <SearchInput
          value={searchTerm}
          onChange={onSearchChange}
          placeholder="호실번호, 입주자명, 시설물명, 담당자명으로 검색..."
          disabled={disabled}
        />
      </div>

      {searchStats && (
        <SearchStats
          total={searchStats.total}
          filtered={searchStats.filtered}
          isSearching={searchStats.isSearching}
        />
      )}
    </div>
  </div>
));

SearchInput.displayName = 'SearchInput';
SearchStats.displayName = 'SearchStats';
BillingSettingsFilters.displayName = 'BillingSettingsFilters';

export default BillingSettingsFilters;